import axios from "axios";
import HttpCliente from '../services/HttpClient'

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const getEventos = (request) => {
    return new Promise( (resolve, reject) => {
        instancia.get(`/api/properties?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}&search=${request.search}`)
        .then( response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api",error);
            
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    })
};

export const searchProperties = (request) => {
    console.log('request: ', request);
    return new Promise( (resolve, reject) => {
        let url = '/api/properties/with-images?';
        let params = [];

        // Evaluamos cada parámetro antes de añadirlo a la URL
        if (request.pageNumber > 0) {
            params.push(`pageNumber=${encodeURIComponent(request.pageNumber)}`);
        }
        if (request.pageSize > 0) {
            params.push(`pageSize=${encodeURIComponent(request.pageSize)}`);
        }
        if (request.ownerId !== undefined && request.ownerId !== '') {
            params.push(`ownerId=${encodeURIComponent(request.ownerId)}`);
        }
        if (request.name !== undefined && request.name !== '') {
            params.push(`name=${encodeURIComponent(request.name)}`);
        }
        if (request.address !== undefined && request.address !== '') {
            params.push(`address=${encodeURIComponent(request.address)}`);
        }
        if (request.priceMin > 0) {
            params.push(`priceMin=${encodeURIComponent(request.priceMin)}`);
        }
        if (request.priceMax > 0) {
            params.push(`priceMax=${encodeURIComponent(request.priceMax)}`);
        }
        // Concatenamos los parámetros con '&' y los añadimos a la URL base
        url += params.join('&');

        console.log('url: ', url);
        // Realizamos la petición GET con la URL construida
        HttpCliente.get(url)
        .then(response => {
            resolve(response);
        })
        .catch( error => {
            //console.log(error);
            reject(error.response);
        });
    })
};

export const createProperty = async (property)=>{
    try {
        const response = await instancia.post("/api/properties", property);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}

export const createPropertyImage = async (propertyImage)=>{
    try {
        const response = await instancia.post("/api/propertyimages", propertyImage);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}

export const createPropertyTrace = async (propertyTrace)=>{
    try {
        const response = await instancia.post("/api/propertytraces", propertyTrace);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}

export const getPropertyById = async (id) => {
     try {
        const response = await instancia.get(`/api/properties/${id}`);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}

export const getImagesByPropertyId = async (id) => {
     try {
        const response = await instancia.get(`/api/propertyimages/by-property/${id}`);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}

export const updateProperty = async (id, property)=>{
    console.log('llega a action prperty: ', property);
    try {
        const response = await instancia.put(`/api/properties/${id}`, property);
        console.log('response al put: ', response);
        return response;
    } catch (error) {
        console.error('Error en updateProperty:', error);
        if (error.response) {
            // Error de respuesta del servidor (ej: 400, 500)
            return error.response;
        } else if (error.request) {
            // Error de conexión (no se recibió respuesta)
            return {
                status: 503,
                data: { message: "No se pudo conectar al servidor" }
            };
        } else {
            // Otros errores (ej: configuración incorrecta)
            return {
                status: 500,
                data: { message: error.message || "Error al actualizar la propiedad" }
            };
        }
    }
}